import { useContext } from 'react'
import { FaWhatsapp } from 'react-icons/fa'
import { HiOutlineMail, HiOutlinePhone } from 'react-icons/hi'
import { motion } from 'framer-motion';
import ContextStates from '../context/ContextStates';
import { areaAnimateLR, areaAnimateRL, areaAnimateS } from './Animations';
import { Link } from 'react-router-dom';

const Footer = () => {
    const { nombre } = useContext(ContextStates)
    const today = new Date();
    const year = today.getFullYear();


    return (
        <motion.footer className="bg-slate-50 text-center lg:text-left text-black font-sans"
            initial={"offscreen"}
            whileInView={"onscreen"}
            viewport={{ once: true, amount: 0.1 }}
            variants={areaAnimateS}
        >
            <div className="flex justify-center items-center lg:justify-between p-6 border-b border-gray-100">
                <div className="mr-12 hidden lg:block">
                    <span>Contáctanos</span>
                </div>
                <div className="flex justify-center">
                    <a
                        href="https://wa.me/543812472378"
                        className="mr-6 text-black"
                        target={"_blank"}
                    >
                        <FaWhatsapp />
                    </a>
                </div>
            </div>
            <div className="mx-6 py-10 text-center md:text-left">
                <div className="grid grid-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    <motion.div
                        className=""
                        initial={"offscreen"}
                        whileInView={"onscreen"}
                        viewport={{ once: true, amount: 0.1 }}
                        variants={areaAnimateS}
                    >
                        <Link to="/">
                            <div className='w-10/12 mx-auto'>
                                <p>{nombre}</p>
                            </div>
                        </Link>
                    </motion.div>
                    <motion.div
                        className=""
                        initial={"offscreen"}
                        whileInView={"onscreen"}
                        viewport={{ once: true, amount: 0.1 }}
                        variants={areaAnimateS}
                    >
                        <h6 className="uppercase font-semibold mb-4 flex justify-center md:justify-start">
                            {'Nuestros productos'}
                        </h6>
                        <p className="mb-4">
                            <Link to="/promociones" className="text-black">Promociones</Link>
                        </p>
                        <p className="mb-4">
                            <Link to="/contacto" className="text-black">Nuestros productos</Link>
                        </p>
                        <p className="mb-4">
                            <Link to="/" className="text-black">{''}</Link>
                        </p>
                    </motion.div>
                    <motion.div
                        className=""
                        initial={"offscreen"}
                        whileInView={"onscreen"}
                        viewport={{ once: true, amount: 0.1 }}
                        variants={areaAnimateS}
                    >
                        <h6 className="uppercase font-semibold mb-4 flex justify-center md:justify-start">
                            {''}
                        </h6>

                        <p className="mb-4">
                            
                        </p>
                        <p>
                            
                        </p>
                    </motion.div>
                    <motion.div
                        className=""
                        initial={"offscreen"}
                        whileInView={"onscreen"}
                        viewport={{ once: true, amount: 0.1 }}
                        variants={areaAnimateS}
                    >
                        <h6 className="uppercase font-semibold mb-4 flex justify-center md:justify-start">
                            {'Contacto'}
                        </h6>
                        <p className="flex items-center justify-center md:justify-start mb-4">
                            <HiOutlineMail className='mr-1' />
                            info@{(nombre).toLowerCase()}.com.ar
                        </p>
                        <p className="flex items-center justify-center md:justify-start mb-4">
                            <HiOutlinePhone className='mr-1' />
                            + 54 381 684-1438
                        </p>
                        <a
                            className="flex items-center justify-center md:justify-start mb-4"
                            href='https://wa.me/543812472378'
                            target={"_blank"}
                            rel='noreferrer'
                        >
                            <FaWhatsapp className="mr-1" aria-hidden="true" />
                            + 54 381 2472378
                        </a>
                    </motion.div>

                </div>
            </div>
            <motion.div
                className="text-center p-6"
                initial={"offscreen"}
                whileInView={"onscreen"}
                viewport={{ once: true, amount: 0.1 }}
                variants={areaAnimateS}
            >
                <span>© {year} Copyright:</span>
                <Link className="text-black font-semibold" to="https://mirx.com.ar">Mirx Software</Link>
            </motion.div>
        </motion.footer>
    )
}

export default Footer